var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportStepTwoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.897,
    height: 22.547,
    viewBox: "0 0 19.897 22.547",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add_contacts",
    "data-name": "Add contacts",
    transform: "translate(-666.325 -688.453)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "contact_1_",
    "data-name": "contact (1)",
    transform: "translate(666.325 688.453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M15.9,13.522A6.314,6.314,0,0,0,11.2,8.73a4.948,4.948,0,1,0-6.371,0A6.305,6.305,0,0,0,0,14.853v4.908H11.19A4.528,4.528,0,1,0,15.9,13.522ZM4.408,4.948A3.611,3.611,0,1,1,8.019,8.559,3.615,3.615,0,0,1,4.408,4.948ZM10.841,18.02c0,.136.006.271.018.4H1.337V14.853A4.963,4.963,0,0,1,6.294,9.9H9.743a4.966,4.966,0,0,1,4.789,3.674,4.535,4.535,0,0,0-3.691,4.45Zm4.528,3.191A3.191,3.191,0,1,1,18.56,18.02,3.195,3.195,0,0,1,15.369,21.211Zm0,0",
    transform: "translate(0 0)",
    fill: "#969fb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M14.513,14.323H13.176v1.2h-1.2v1.337h1.2v1.2h1.337v-1.2h1.2V15.527h-1.2Zm0,0",
    transform: "translate(1.525 1.824)",
    fill: "#969fb1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportStepTwoIcon);
export default __webpack_public_path__ + "static/media/import-step-two-icon.ab31654fc92fff0c2e5f783e32a3ed45.svg";
export { ForwardRef as ReactComponent };